export enum ContenidoEnum {
    NO_VIGENTE = 'NO_VIGENTE',
    SERIE_NO_COINCIDE = 'SERIE_NO_COINCIDE',
    SIN_INTENTOS = 'se le han agotado los intentos'
}
